/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsPullRequestCompletion" />
import { format } from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "Wit/LinkedWorkItemsDropdown/Resources";
import { getLinkedWorkItemsPullRequestDetailViewService } from "../LinkedWorkItemsPullRequestDetailViewService";

interface IPullRequestCompletionDetails {
    description: string;
}

type PullRequestCompletionTransformer = (details: IPullRequestCompletionDetails) => Promise<void>;

interface GitRepository {
    id: string;
    project: { id: string };
}

interface ILinkedWorkItemsPullRequestDetailsProps {
    addCompletionTransformer: (transformer: PullRequestCompletionTransformer) => void;
    pullRequestId: number;
    repository: GitRepository;
}

export class LinkedWorkItemsPullRequestCompletion extends VssComponent<ILinkedWorkItemsPullRequestDetailsProps> {
    private readyPromise: Promise<void>;

    public componentDidMount() {
        this.props.addCompletionTransformer(this.transformDescriptionBeforeCompletion);
    }

    public render() {
        // This is a non-visible component only intended to transform description before completion.
        return null;
    }

    private transformDescriptionBeforeCompletion = (details: IPullRequestCompletionDetails): Promise<void> => {
        const viewService = getLinkedWorkItemsPullRequestDetailViewService(this.context.pageContext);
        if (!this.readyPromise) {
            this.readyPromise = new Promise<void>((resolve) => {
                const { pullRequestId, repository } = this.props;
                const ready = viewService.getLinkedWorkItems(repository.project.id, repository.id, pullRequestId).ready;
                if (ready.value) {
                    resolve();
                } else {
                    ready.subscribe((ready) => {
                        if (ready) {
                            resolve();
                        }
                    });
                }
            });
        }

        return this.readyPromise.then(() => {
            const workItemIds = viewService.getLinkedWorkItemIds();
            if (workItemIds.size > 0) {
                const workItemIdsAsArray: string[] = [];
                workItemIds.forEach((id) => {
                    workItemIdsAsArray.push(`#${id}`);
                });
                details.description = format(Resources.DescriptionWithRelatedWorkItems, details.description, workItemIdsAsArray.join(", "));
            }
        });
    };
}

Components.add("WIT.LinkedWorkItemsPullRequestCompletion", LinkedWorkItemsPullRequestCompletion);
